import axios from "axios";

const ABOUT_US_API_URL = `${process.env.REACT_APP_API_URL}/aboutus`; // Replace with your actual API URL

const customHeaders = {
  'Content-Type': 'application/json',
};

// Fetch About Us details
export const fetchAboutUs = async () => {
  const response = await axios.get(`${ABOUT_US_API_URL}`, { headers: customHeaders });
  return response.data;
};

// Create or add About Us details
export const addAboutUs = async (newAboutUs: { title: string; description: string; is_active: boolean; image?: string }) => {
  const response = await axios.post(`${ABOUT_US_API_URL}`, newAboutUs, {
    headers: customHeaders,
  });
  return response.data;
};

// Update About Us details
export const updateAboutUs = async (updatedAboutUs: { title: string; description: string; is_active: boolean; image?: string }) => {
  const response = await axios.put(`${ABOUT_US_API_URL}`, updatedAboutUs, {
    headers: customHeaders,
  });
  return response.data;
};
